import dayjs from 'dayjs';

export function isPastQuarterMonth(quarterMonth: string, currentOpenMonth: string): boolean {
  const quarterMonthDate = dayjs(quarterMonth);
  const currentOpenMonthDate = dayjs(currentOpenMonth);

  return quarterMonthDate.isBefore(currentOpenMonthDate);
}
